import '../styles/signinstyle.css'
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Divider } from '@material-ui/core';
//import { red } from '@material-ui/core/colors';


export class SignInPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputUsername: "",
            inputPassword: "",
            rememberMe: false,
            title: "Sign In",
            isFetching: false,
            loginMessage: "",
        };

        localStorage.removeItem("authtoken");
    }

    handleChange = (e) => {
        //console.log(e.target.name + " " + e.target.value);
        this.setState({ [e.target.name]: e.target.value });
    }

    handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            //console.log('Enter key pressed')
            if (!this.state.isFetching) {
                this.loginAction(e);
            }
        }
    }

    componentDidMount() {
        //this.checkForLogin();
        //this.loginAction();
    }

    //checkForLogin = () => {
    // setter
    //localStorage.setItem("authtoken", 555888);
    //// getter
    //localStorage.getItem('myData');
    //// remove
    //localStorage.removeItem('myData');
    //// remove all
    //localStorage.clear();
    //}

    //handleInputChange = e => {
    //    let tmpformdatas = this.state.formdatas;
    //    tmpformdatas[e.target.name] = e.target.value;
    //    this.setState({
    //        formdatas: tmpformdatas
    //    });
    //};

    loginAction = async (event) => {
        
        event.preventDefault();

        await this.setState({ isFetching: true });

        localStorage.removeItem("authtoken");

        var postFormData = new FormData();
        postFormData.append("operation", "Auth");

        //var postData = this.state.formdatas;
        var postData = this.state;
        Object.keys(postData).forEach((key) => {
            postFormData.append(key, postData[key]);
        });

        //let localauthtok = localStorage.getItem("authtoken");

        await fetch(global.variables.API_CHECKLOGIN, {
               
            method: "POST",
            body: postFormData
        })
            .then(response => response.json())
            .then(result => {

                console.log("LOGIN RESPONSE:", result);

                if (result.resultstate === "OK" && result.authresp === 1) {
                    localStorage.setItem("authtoken", result.authtoken);
                    window.location.href = "/dashboard";
                    //window.location.href = "/projectlist";
                } else if (result.resultstate === 0 &&
                    result.authresp === 2) {
                    localStorage.setItem("authtoken", result.authtoken);
                    // Check for Token Authentication Again
                    window.location.href = "/dashboard";
                } else {
                    if (result.authresp === 3 || result.authresp === 4) {
                        this.setState({ loginMessage: "Incorrect Username or Password" });
                    } else {
                        window.location.href = "/login";
                    }
                }
            }).catch(() => {
            
                window.location.href = "/login";
            });

        await this.setState({ isFetching: false });
    };

    render() {
        const {
            inputUsername,
            inputPassword,
            rememberMe,
            isFetching,
            loginMessage
        } = this.state
        return (
            <div className="romis-signin-bg">
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card className="romis-img-card">
                        <div style={{ textAlign: "center", float: "left", paddingTop: 50 }}>
                            <img src="/images/financed.png" alt="" width="183px" height="93px" />
                            <Typography variant="caption" display="block" gutterBottom >
                                This project is co-financed by the European Union
                            </Typography>
                            <Typography variant="caption" display="block" gutterBottom >
                                and the Republic of Turkey. TEST
                            </Typography>
                        </div>
                        <Divider orientation="vertical" />
                        <div style={{ textAlign: "center", float: "right" }}>

                            <img src="/images/rom_dark.png" alt="" width="384px" height="216px" />

                        </div>
                    </Card>

                </Grid>
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card style={{ maxHeight: 450 }}>
                        <CardHeader title="Login to Continue" className='romis-card-header' />
                        <CardContent>
                            <Typography variant="subtitle1" gutterBottom>Welcome back, please sign in with your account.</Typography>
                            <p style={{ color: 'red' }}>{loginMessage}</p>
                            <Grid item>
                                <TextField
                                    label="E-mail Adress:"
                                    placeholder="Enter email"
                                    margin="normal" fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={inputUsername}
                                    onChange={this.handleChange.bind(this)}
                                    name="inputUsername"
                                    onKeyDown={this.handleKeyDown.bind(this)}
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Password"
                                    placeholder="Password"
                                    margin="normal"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={inputPassword}
                                    onChange={this.handleChange.bind(this)}
                                    name="inputPassword"
                                    type="password"
                                    onKeyDown={this.handleKeyDown.bind(this)}
                                />
                            </Grid>
                            <Grid item>
                                <FormControlLabel control={<Checkbox name="rememberMe"
                                    value={rememberMe} checked={rememberMe}
                                    onChange={this.handleChange.bind(this)} />} label="Remember Me" />
                            </Grid>
                            <Grid item>
                                <a href="/forgotpassword">Forgot Password</a>
                            </Grid>
                            <Grid item style={{ textAlign: "center" }}>
                                <Button variant="contained" color="primary"
                                    onClick={this.loginAction.bind(this)}
                                    disabled={isFetching ? true : false}> Submit </Button>
                            </Grid>
                        </CardContent>
                    </Card>

                </Grid>
                <Grid>
                    <div align="center">
                        <img src="/images/cfcu.png" alt="" width="62px" height="66px" />
                        <img src="/images/eptisa.png" alt="" width="105px" height="80px" style={{ marginLeft: 120, marginRight: 120 }} />
                        <img src="/images/europan.png" alt="" width="46px" height="46px" />
                    </div>
                </Grid>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/pages/SignInPage.js